const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Categories+API

function getCategories(categoryId) {
    let url = `/api/catalog/categories/${categoryId}`;

    return ufeApi.makeRequest(url, { method: 'GET' }).
        then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = getCategories;
